/*
 * File: deliveryAddressDescriptionFilter.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 24 Jan 2022 11:53:29 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterDescription } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

/* ****************** Interfaces ****************** */
interface Props {
  isDisabled?: boolean;
}

// eslint-disable-next-line react/prop-types
export const DeliveryAddressDescriptionFilter = ({ isDisabled }: Props): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((event: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterDescription(event.target.value));
  }, 500);

  useEffect(() => {
    return (): void => {
      dispatch(setFilterDescription(undefined));
    };
  }, [dispatch]);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput placeholder="Description" width={150} disabled={isDisabled} onChange={handleInputChange} />
    </Space>
  );
};
